export const GENERATE_VAT_RETURN_REQUEST = 'GENERATE_VAT_RETURN_REQUEST';
export const GENERATE_VAT_RETURN_SUCCESS = 'GENERATE_VAT_RETURN_SUCCESS';
export const GENERATE_VAT_RETURN_FAILURE = 'GENERATE_VAT_RETURN_FAILURE';

export const GET_VAT_RETURN_ENTRY_LIST_REQUEST = 'GET_VAT_RETURN_ENTRY_LIST_REQUEST';
export const GET_VAT_RETURN_ENTRY_LIST_SUCCESS = 'GET_VAT_RETURN_ENTRY_LIST_SUCCESS';
export const GET_VAT_RETURN_ENTRY_LIST_FAILURE = 'GET_VAT_RETURN_ENTRY_LIST_FAILURE';

export const DOWNLOAD_SAFT_REQUEST = 'DOWNLOAD_SAFT_REQUEST';
export const DOWNLOAD_OFFICIAL_XML_REQUEST = 'DOWNLOAD_OFFICIAL_XML_REQUEST';
export const DOWNLOAD_VAT_RETURN_REQUEST = 'DOWNLOAD_VAT_RETURN_REQUEST';
export const DOWNLOAD_FILED_RETURN_REQUEST = 'DOWNLOAD_FILED_RETURN_REQUEST';

export const DOWNLOAD_SUCCESS = 'DOWNLOAD_SUCCESS';
export const DOWNLOAD_FAILURE = 'DOWNLOAD_FAILURE';

export const SEND_VAT_RETURN_EMAIL_REQUEST = 'SEND_VAT_RETURN_EMAIL_REQUEST';
export const SEND_VAT_RETURN_EMAIL_SUCCESS = 'SEND_VAT_RETURN_EMAIL_SUCCESS';
export const SEND_VAT_RETURN_EMAIL_FAILURE = 'SEND_VAT_RETURN_EMAIL_FAILURE';

export const GET_VAT_RETURN_BANK_DETAILS_REQUEST = 'GET_VAT_RETURN_BANK_DETAILS_REQUEST';
export const GET_VAT_RETURN_BANK_DETAILS_SUCCESS = 'GET_VAT_RETURN_BANK_DETAILS_SUCCESS';
export const GET_VAT_RETURN_BANK_DETAILS_FAILURE = 'GET_VAT_RETURN_BANK_DETAILS_FAILURE';

export const GET_CZECH_ECONOMIC_ACTIVITY_LIST_REQUEST = 'GET_CZECH_ECONOMIC_ACTIVITY_LIST_REQUEST';
export const GET_CZECH_ECONOMIC_ACTIVITY_LIST_SUCCESS = 'GET_CZECH_ECONOMIC_ACTIVITY_LIST_SUCCESS';
export const GET_CZECH_ECONOMIC_ACTIVITY_LIST_FAILURE = 'GET_CZECH_ECONOMIC_ACTIVITY_LIST_FAILURE';

export const CLEAR_VAT_RETURN_DATA = 'CLEAR_VAT_RETURN_DATA';

export const GET_ITALY_VAT_RETURN_ENTRY_LIST_REQUEST = 'GET_ITALY_VAT_RETURN_ENTRY_LIST_REQUEST';
export const GET_ITALY_VAT_RETURN_ENTRY_LIST_SUCCESS = 'GET_ITALY_VAT_RETURN_ENTRY_LIST_SUCCESS';
export const GET_ITALY_VAT_RETURN_ENTRY_LIST_FAILURE = 'GET_ITALY_VAT_RETURN_ENTRY_LIST_FAILURE';
